import { render } from "./Mifraha.vue?vue&type=template&id=95b97e20&scoped=true"
import script from "./Mifraha.vue?vue&type=script&lang=js"
export * from "./Mifraha.vue?vue&type=script&lang=js"

import "./Mifraha.vue?vue&type=style&index=0&id=95b97e20&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95b97e20"]])

export default __exports__